/* @flow */
import pluralize from 'pluralize';
import * as React from 'react';
import { FormattedNumber } from 'react-intl';
import AdminHeadline from 'admin/components/AdminHeadline';
import NumberWithLabel from 'components/NumberWithLabel';
import Text from 'components/Text';
import TextWithTooltip from 'components/TextWithTooltip';

type Props = {
  data: {
    announcements: number,
    conversations: number,
  },
  duration: 'last month' | 'last week' | 'yesterday',
  messagesDeliveredLastYear?: number,
};

function AdminStatisticsCommunicationChartHeadlineMessagesTextWithTooltip(props) {
  return (
    <TextWithTooltip
      tooltip="Total number of announcements and chats"
      tooltipPlacement="bottom"
      weight="bold">
      <NumberWithLabel {...props} label="message" />
    </TextWithTooltip>
  );
}

const AdminStatisticsCommunicationChartHeadline = (props: Props) => {
  const { data, duration, messagesDeliveredLastYear } = props;

  return (
    <AdminHeadline>
      <AdminStatisticsCommunicationChartHeadlineMessagesTextWithTooltip
        value={data.announcements + data.conversations}
      />{' '}
      were delivered on Remind {duration}.
      {typeof messagesDeliveredLastYear === 'number' &&
        messagesDeliveredLastYear > 0 && (
          <span>
            {' '}
            <AdminStatisticsCommunicationChartHeadlineMessagesTextWithTooltip
              value={messagesDeliveredLastYear}
            />{' '}
            were delivered in the last year.
          </span>
        )}
      <br />
      This includes{' '}
      <Text weight="bold">
        <NumberWithLabel label="announcement" value={data.announcements} />
      </Text>{' '}
      and{' '}
      <TextWithTooltip
        tooltip="Responses to a teacher’s announcements"
        tooltipPlacement="bottom"
        weight="bold">
        <FormattedNumber value={data.conversations} />{' '}
        {pluralize('conversation', data.conversations)} and{' '}
        {pluralize('reaction', data.conversations)}
      </TextWithTooltip>
      .
    </AdminHeadline>
  );
};

export default AdminStatisticsCommunicationChartHeadline;
